import {charcoal} from '../../sass/v2/_exports.sass';

export const UnderlineTextIcon = ({color = charcoal, className = '', ratio = 1}) => {
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};
  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Underline text</title>
      <path
        d="M7.12891 26.8333V24.8333H24.8723V26.8333H7.12891ZM16.0005 22.0383C13.9271 22.0383 12.3087 21.4088 11.1456 20.15C9.98224 18.8911 9.40057 17.2043 9.40057 15.0896V4.55127H11.8722V15.2127C11.8722 16.5597 12.2303 17.6393 12.9466 18.4513C13.6628 19.2633 14.6808 19.6693 16.0005 19.6693C17.3204 19.6693 18.3384 19.2633 19.0545 18.4513C19.7708 17.6393 20.1289 16.5597 20.1289 15.2127V4.55127H22.6005V15.0896C22.6005 17.2043 22.0189 18.8911 20.8556 20.15C19.6924 21.4088 18.0741 22.0383 16.0005 22.0383Z"
        fill={color}
      />
    </svg>
  );
};
